import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog'; 
@Component({
  selector: 'app-landing-dialog',
  templateUrl: './landing-dialog.component.html',
  styleUrls: ['./landing-dialog.component.scss']
})
export class LandingDialogComponent implements OnInit {
  
  fullErrorContent = false;
  bdqQuote = false;
  constructor(public dialogRef: MatDialogRef<LandingDialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    const sourceIndicator = sessionStorage.getItem('sourceIndicator');
    if(['BW', 'BI', 'BDQI'].includes(sourceIndicator)) {
      this.bdqQuote = true;
    }
    this.fullErrorContent = this.data.errorCd === 'EL005';
    // Dynamically update the phone number in the popup screen
    this.invoca(window, document, 'solutions.invocacdn.com/js/invoca-latest.min.js', '2013/1325511193');
  }
  /**
   * Invoca Script
   * US348410: Dynamically update the phone number in the popup screen
   */
  invoca(i, n, v, o): void {
    i.InvocaTagId = o;
    const s = n.createElement('script'); s.type = 'text/javascript';
    s.async = true;
    s.src = ('https:' === n.location.protocol ? 'https://' : 'http://') + v;
    const fs = n.getElementsByTagName('script')[0]; fs.parentNode.insertBefore(s, fs);
  }
}
